/** Product names for the tier-mode slugs served by GET /api/admin/plan-tiers. */
export const MODE_LABELS: Record<string, string> = {
  dictation: "Dictaat",
  ambient: "Sjabloon",
  translator: "Vertaal",
  patient_note: "Patiëntnota",
};

export function modeLabel(slug: string): string {
  return MODE_LABELS[slug] ?? slug;
}
